import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

const Button = ({
  size = "md",
  variant = "primary",
  outline,
  text,
  icon = {},
  type,
  ...rest
}) => {
  const getIcon = () => <GetIcon type="regular" size={size} {...icon} />;

  return (
    <S.ButtonStylesStructure
      $variant={variant}
      $outline={outline}
      size={size}
      type={type}
      {...rest}
    >
      {(icon.position === "left" || icon.position === "both") && getIcon()}
      {text}
      {(icon.position === "right" || icon.position === "both") && getIcon()}
    </S.ButtonStylesStructure>
  );
};

export default Button;
